export class NotificationParams {
    page? = 1;
    limit? = 10;
    targetType?: number;
    createdByRowGuid?: string;
    senderRowGuid?: string;
}
